export default __webpack_public_path__ + "static/media/silver.233ac762.png";